import * as React from "react";
import { List, Button } from "antd";
import styled from "styled-components";
import { Page } from "../lib/model/Page";
import * as _ from "lodash";
import { ListItem } from "../lib/model/ListItem";

export const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  font-weight: 300;
`;

type Props<T> = {
  loadData: (after?: string) => Promise<Page<T>>;
  renderItem: (item: ListItem<T>) => React.ReactElement;
  getSectionIdentifier?: (item: T) => string;
};

type State<T> = {
  cursor?: string;
  isLoading: boolean;
  data: ListItem<T>[];
};

export class PagedList<T> extends React.Component<Props<T>, State<T>> {
  readonly state: State<T> = {
    cursor: undefined,
    isLoading: true,
    data: []
  };
  readonly placeholderData: ListItem<T>[] = Array(25)
    .fill(0)
    .map(() => {
      return { isPlaceholder: true };
    });
  render() {
    const { isLoading, data, cursor } = this.state;
    const { renderItem } = this.props;

    const loadMore =
      !isLoading && cursor ? (
        <div
          style={{
            textAlign: "center",
            marginTop: 18,
            height: 33
          }}
        >
          <Button style={{ borderRadius: 0 }} onClick={this.handleLoadData}>
            mehr laden
          </Button>
        </div>
      ) : null;
    return (
      <List
        itemLayout="horizontal"
        loadMore={loadMore}
        dataSource={data}
        renderItem={renderItem}
        split={false}
      />
    );
  }

  componentDidMount = () => {
    this.handleLoadData();
  };

  handleLoadData = async () => {
    const { loadData, getSectionIdentifier } = this.props;
    this.setState({
      isLoading: true,
      data: [...this.state.data, ...this.placeholderData]
    });
    const cursor = this.state.cursor;

    const page = await loadData(cursor);
    const realData = this.state.data.filter(o => !!o.item);
    const completeData = [
      ...realData,
      ...page.results.map(i => {
        return { isPlaceholder: false, item: i };
      })
    ];
    if (!!getSectionIdentifier) {
      const sections = _.uniq(
        completeData.map(d => getSectionIdentifier(d.item!))
      );
      const sectionedData: ListItem<T>[] = _.flatMap(sections, s => [
        { isPlaceholder: false, sectionHeader: s },
        ...completeData.filter(d => getSectionIdentifier(d.item!) === s)
      ]);
      this.setState({
        data: sectionedData,
        cursor: page.cursors.after,
        isLoading: false
      });
    } else {
      this.setState({
        data: completeData,
        cursor: page.cursors.after,
        isLoading: false
      });
    }
  };
}
